import React, {useReducer, useCallback} from 'react'
import getUsersReducer from '../../state/user/get-user/reducer'
import getUserTemplatesReducer from '../../state/user/get-user-templates/reducer'

import {getUser} from '../../state/user/get-user/actions'
import {getSearchTemplate} from '../../state/user/get-user-templates/actions'

const UsersContext = React.createContext()

function UsersContextProvider(props) {
  const userState = {
    users: [],
    error: null,
    isLoading: false,
  }

  const templateUserState = {
    error: null,
    isLoading: true,
    templates: [],
  }

  const [users, userDispatch] = useReducer(getUsersReducer, userState)
  const getAllUsers = useCallback((params = {search: null}) => {
    getUser(userDispatch, params.search)
  }, [])

  const [userTemplates, templateUsersDispatch] = useReducer(
    getUserTemplatesReducer,
    templateUserState
  )
  const getAllUserTemplates = useCallback(
    ({query = ''}) => getSearchTemplate(query, templateUsersDispatch),
    []
  )

  const value = {
    users,
    userTemplates,

    getAllUsers,
    getAllUserTemplates,
  }

  return <UsersContext.Provider value={value}>{props.children}</UsersContext.Provider>
}

const UsersContextConsumer = UsersContext.Consumer

export {UsersContext, UsersContextProvider, UsersContextConsumer}
